import * as React from "react";
const SvgGom = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	viewBox: "0 0 42.5 42.5",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "currentColor",
	d: "M39.3 35.3h-1.9L22.4 19c-.3-.4-.8-.4-1.1 0l-15 16.3H4.4c-1.9 0-3-2.2-1.8-3.7l8.2-10.3L20 9.6c.9-1.2 2.7-1.2 3.6 0l9.3 11.7L41 31.7c1.2 1.4.1 3.6-1.7 3.6"
}));
export default SvgGom;
